/**
 * @fileoverview hook to manage the media library teams
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { mediaLibraryTeamsCacheKey } from "./constants";
import type { MediaLibraryTeamsParams, MediaLibraryTeamsResult } from "./types";
import { isMediaLibraryTeamsResult } from "./validators";

/**
 * fetch teams for media library associated to a single app group from backend
 *
 * @param appGroupId - the current app group
 *
 * @returns the data from the fetch in a promise
 */
export const getMediaLibraryTeams = reactQueryFetcherAdapter(
  mediaLibraryTeamsCacheKey,
  (signal: AbortSignal, { appGroupId }: MediaLibraryTeamsParams): Promise<MediaLibraryTeamsResult> => {
    return fetch(
      `/engagement/${appGroupId}/media_library_territories`,
      "GET",
      {
        app_group_id: appGroupId,
      },
      { signal }
    );
  },
  isMediaLibraryTeamsResult
);
